import { ReactComponent as HomeIcon } from "assets/images/house-regular-full 1.svg";
import { useNavigate } from "react-router-dom";
import SidebarNavItem from "./SidebarNavItem";
import { useMainNavActiveState } from "./useMainNavActiveState";

export default function SidebarHomeLink() {
  const navigate = useNavigate();
  const { isHomeActive } = useMainNavActiveState();

  return (
    <SidebarNavItem
      label="Home"
      icon={<HomeIcon />}
      isActive={isHomeActive}
      onClick={() => navigate("/home")}
    />
  );
}
